<template>
  <p v-if="showNightTip">下一交易日部门报价已更新,请选择查询日期</p>

  <form @submit.prevent="handleSubmit" class="search-form">

    <div class="auto-complete-input">
      <input
        type="text"
        v-model="searchQuery"
        @input="handleInput"
        @focus="showSuggestions = true"
        @blur="handleBlur"
        :placeholder="label"
        class="input-field"
      />
      <ul v-if="showSuggestions && suggestions.length" class="suggestions-list">
        <li
          v-for="(suggestion, index) in suggestions"
          :key="index"
          @click="selectSuggestion(suggestion)"
          class="suggestion-item"
        >
          {{ suggestion }}
        </li>
      </ul>
    </div>
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="选择日期"
        :default-value="new Date()"
        class="date-picker"
      ></el-date-picker>
    <button type="submit" :disabled="isSubmitting" class="submit-button">{{ submitText }}</button>
     <!-- 操作按钮组 -->
      <div class="button-group vertical-spacing">
        <button
           v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button"
          @click="viewReport()"
        >
          {{ loading ? '加载中...' : '查看财报' }}
        </button>
        <button
           v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe()"
        >
          {{ loading ? '加载中...' : '同花顺扫雷' }}
        </button>
         <button
            v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('fhps')"
        >
          {{ loading ? '加载中...' : '个股分红' }}

        </button>

        <button
            v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('thshot')"
        >
          {{ loading ? '加载中...' : '同花顺热榜' }}

        </button>

          <button
          v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="detail()"
        >
          {{ loading ? '加载中...' : '走势' }}
        </button>
         <button
          v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('readpe')"
        >
          {{ loading ? '加载中...' : '市盈率' }}

        </button>
        <button
          v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('ydyy')"
        >
          {{ loading ? '加载中...' : '异动原因' }}

        </button>
        <button
          v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('rzrq')"
        >
          {{ loading ? '加载中...' : '融资融券' }}

        </button>

           <button
          v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('tssy')"
        >
          {{ loading ? '加载中...' : '季报分析' }}
             </button>
       <button
          v-if="isAdmin"
          type="button"
          :disabled="loading"
          class="submit-button secondary-btn"
          @click="openInIframe('gp')"
        >
          {{ loading ? '加载中...' : '股评' }}

       </button>


      </div>
  </form>
   <div class="calendar-container">
  <!-- 控制按钮 -->
  <div class="calendar-header">
    <button @click="toggleCalendar" class="toggle-button">
      {{ isCalendarVisible ? '隐藏公司事件日历' : '显示公司事件日历' }}
    </button>
  </div>
</div>
   <!-- 使用组件 -->
    <MobileIframeViewer
      v-if="showIframe"
      :show-iframe="showIframe"
      :iframe-src="iframeSrc"
      @close="closeIframe"
    />
</template>

<script>
import axios from 'axios';
import { formatDate } from '@/utils/commonMethods';
import MobileIframeViewer from '@/components/MobileIframeViewer.vue';
import { ElMessage } from 'element-plus';
export default {
 components: {
    MobileIframeViewer
  },
  props: {
    isSubmitting: Boolean,
    calendarEvents: Array,
    label: {
      type: String,
      default: '股票名称或代码'
    },
    inputType: {
      type: String,
      default: 'text'
    },
    inputId: {
      type: String,
      default: 'stock-code'
    },
    submitText: {
      type: String,
      default: '查询'
    }
  },
  data() {
    return {
      showIframe: false,
      date: new Date(),
      searchQuery: '',
      suggestions: [],
      showSuggestions: false,
      timeout: null,
      userRole: localStorage.getItem('username') || '',
     isCalendarVisible: false, // 控制日历是否可见
     selectedDate: '',
    selectedEvents: []
    };
  },
  watch: {

},
  computed: {
   formattedDate() {
      return this.date ? formatDate(this.date) : '';
    },
    isAdmin() {
        return this.userRole === 'admin1984'|| this.userRole === '13950354253';
    },
     // 新增计算属性：判断是否为晚上9点
    showNightTip() {
      const now = new Date();
      const hours = now.getHours();
      // 晚上9点（21点）显示提示
      return hours >= 21;
    }

  },
  created() {
    this.searchQuery = this.$route.query.searchQuery || '';
     if (this.searchQuery) {
      this.handleSubmit();
    }
    // 初始化事件列表（可以换成接口请求）

  },
  methods: {
   toggleCalendar() {
    this.isCalendarVisible = !this.isCalendarVisible;
  },
 // 判断是否是今天

  isToday(date) {
      const inputDate = new Date(date); // 确保是 Date 对象
      const today = new Date();
      return (
        inputDate.getDate() === today.getDate() &&
        inputDate.getMonth() === today.getMonth() &&
        inputDate.getFullYear() === today.getFullYear()
      );
  }, // 格式化日期为 YYYY-MM-DD
  formatDateStr(date) {
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }, // 判断某天是否有事件


    async fetchSuggestions(query) {
      try {
        const response = await axios.get('/api/stock_list', {
          params: { query }
        });
        this.suggestions = response.data;
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    handleInput() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.searchQuery.length >= 1) {
          this.fetchSuggestions(this.searchQuery);
        } else {
          this.suggestions = [];
        }
      }, 300);
    },
     async viewReport() {
      if (!this.searchQuery) {
        ElMessage.warning('请输入股票代码');
        return;
      }
      this.loading = true;
      try {
        const scode = this.searchQuery.split(' ')[1].substring(0,6);
        this.iframeSrc = `https://x.cmschina.com/app/infomation/reportstock/#/?scode=${scode}&ecode=0&hideTitle=1`;
        this.showIframe = true;
      } finally {
        this.loading = false;
      }
    },


    openInIframe(type = 'report') {
      if(type === 'fhps'){
         const scode = this.searchQuery.split(' ')[1].substring(7,9)+this.searchQuery.split(' ')[1].substring(0,6);
         window.open(`https://xueqiu.com/snowman/S/${scode}/detail#/FHPS`,'_blank');
      }else if(type === 'thshot'){
           const url = `https://eq.10jqka.com.cn/frontend/thsTopRank/index.html?client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no#/`;
           window.open(url,'_blank');

      }else if(type === 'readpe'){
          const scode = this.searchQuery.split(' ')[0];
          window.open(`https://www.iwencai.com/unifiedwap/result?w=${scode}市盈率并解读&querytype=stock`,'_blank');

      }else if(type === 'rzrq'){
          const scode =  this.searchQuery.split(' ')[1].substring(0,6);
           window.open(`https://data.hexin.cn/market/rzrqgg/code/${scode}/?client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no`,'_blank');

      }else if(type === 'ydyy'){
          const scode =  this.searchQuery.split(' ')[1].substring(0,6);
          window.open(`https://flow.10jqka.com.cn/app/anomaly_analysis/history?marketId=17&thsHqCode=${scode}&client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no`,'_blank');

      }else if(type === 'tssy'){
          const scode = this.searchQuery.split(' ')[1].substring(0,6);
          this.iframeSrc = `https://board.10jqka.com.cn/gateway/visual/searchNewResult?client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no#code=${scode}&type=${this.getCurrentYearAndQuarter()}&source=tssy`;
          this.showIframe = true;
      }else if(type === 'gp'){
          const scode = this.searchQuery.split(' ')[1].substring(0,6);
          const url = `https://finance.baidu.com/stock/ab-${scode}`;
          window.open(url,'_blank');

      }else{
          const scode = this.searchQuery.split(' ')[1].substring(0,6);
          this.iframeSrc = `https://bowerbird.10jqka.com.cn/thslc/editor/view/433f6d9Ac0?back_source=wxhy&client_userid=kdfFz&code=${scode}&fontzoom=no&share_hxapp=isc`;
          this.showIframe = true;
      }
    },getCurrentYearAndQuarter() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  let quarter = 'first';

  if (month >= 1 && month <= 4) {
    quarter = 'first';
  } else if (month >= 4 && month <= 7) {
    quarter = 'second';
  } else if (month >= 7 && month <= 11) {
    quarter = 'third';
  } else {
    quarter = 'fourth';
  }

  return `${year}-${quarter}`;
},

      detail( ) {
         const scode = this.searchQuery.split(' ')[1].substring(0,6);
         window.open(`https://admin.58option.cn/stock-detail?stock_code=${scode}`);
    },

    closeIframe() {
      this.showIframe = false;
      this.iframeSrc = '';
    },
    handleBlur() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    selectSuggestion(suggestion) {
      this.searchQuery = suggestion;
      this.suggestions = [];
      this.$emit('select', suggestion); // 触发 select 事件
    },
    handleSubmit() {
     this.$emit('submit', this.searchQuery,this.formattedDate);
    }
  }
};
</script>

<style scoped>
@import '../assets/css/StockSearchForm.css';
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.toggle-button {
  background-color: #409EFF;
  color: white;
  border: none;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.toggle-button:hover {
  background-color: #337ecc;
}

</style>
